export default "__VITE_ASSET__DknuA4GL__"